import React from "react";
import { FormattedMessage } from "react-intl";

interface ChangeTypeCheckboxProps {
    name: string;
    displayName: string;
    changeTypeValue: boolean;
    changeTypeChangedFunction: (name: string, checked: boolean) => void;
    disabled: boolean;
    layerColor?: string;
}

export const ChangeTypeCheckbox = (props: ChangeTypeCheckboxProps) => {
    const { disabled, changeTypeChangedFunction, changeTypeValue, name, displayName, layerColor } = props;
    const id = "changeTypeCheckbox" + name;
    const layerColorStyle = layerColor ? { backgroundColor: layerColor } : { display: "none" };

    return (
        <div key={name}>
            <input
                type={"checkbox"}
                name={name}
                id={id}
                disabled={disabled}
                onChange={(event) => changeTypeChangedFunction(name, event.target.checked)}
                checked={changeTypeValue}
            />
            <label htmlFor={id}>
                <span className={"layerColor"} style={layerColorStyle} />
                <FormattedMessage id={`workspaceChanges.changeTypeCheckbox.${displayName}`} />
            </label>
        </div>
    );
};
